export default "__VITE_ASSET__GDGj3PeQ__"